import { Divider, ListItem, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import PrintUnavailability from 'practice/components/pratice-unavailabilty/print';
import { Fragment, MouseEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface UntraceableCensusManagementMenuProps {
  visibility?: {
    aperturaPratica: boolean;
    stampaPratica: boolean;
  };
  onClick: (event: MouseEvent<HTMLElement>) => void;
  onClose: (event: MouseEvent<HTMLElement>) => void;
  submenuAnchor: Element | null;
  isSubmenuVisible: boolean;
}

const UntraceableCensusManagementMenu = ({
  visibility = {
    aperturaPratica: true,
    stampaPratica: true,
  },
  onClick,
  onClose,
  isSubmenuVisible,
  submenuAnchor,
}: UntraceableCensusManagementMenuProps): React.ReactElement => {
  const navigate = useNavigate();

  const [printUnavailabilityModal, setPrintUnavailabilityModal] = useState<boolean>(false);

  return (
    <Fragment>
      <ListItem onClick={onClick}>
        <ListItemText primary="Gestione Pratica Irreperibilità per censimento" />
      </ListItem>
      <Menu
        id="untraceable-census-menu"
        anchorEl={submenuAnchor}
        open={isSubmenuVisible}
        onClose={onClose}
        PaperProps={{
          style: {
            width: '30ch',
          },
        }}
      >
        {visibility.aperturaPratica
          ? [
              <MenuItem
                key="untraceableCensus-aperturaPratica-menu-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/pratiche/nuova-pratica/censimento/irreperibilita');
                }}
              >
                <Typography variant="inherit">Apertura Pratica</Typography>
              </MenuItem>,
              <Divider
                key="untraceableCensus-aperturaPratica-divider"
                hidden={!visibility.stampaPratica}
              />,
            ]
          : undefined}
        {visibility.stampaPratica
          ? [
              <MenuItem
                key="untraceableCensus-stampaPratica-menu-item"
                onClick={(event) => {
                  onClose(event);
                  setPrintUnavailabilityModal(true);
                }}
              >
                <Typography variant="inherit">Stampa per Prefettura</Typography>
              </MenuItem>,
            ]
          : undefined}
      </Menu>
      <PrintUnavailability
        isOpen={printUnavailabilityModal}
        onClose={() => setPrintUnavailabilityModal(false)}
      />
    </Fragment>
  );
};

UntraceableCensusManagementMenu.displayName = 'Unavailability Management Menu';

export default UntraceableCensusManagementMenu;
